// node modules
import debounce from 'lodash/debounce';
// ui library
import { ErrorCircleIcon } from '@upstox/upstox-ui';
// modules
import Fetch from 'modules/Fetch';
import LocaleStore from 'modules/Localization';
import { ITVNotification } from 'modules/TradingChart/components/TradingView/utils/providers/brokerProvider/notifications/types';
import { broker } from 'modules/TradingChart/consts';
import NotificationsStore from './store';
// constants
import {
  TECH_ISSUE_TITLE,
  FCM_NOTIFICATIONS_DEBOUNCE_DELAY,
} from './constants';

class NotificationsService extends NotificationsStore {
  handleFCMEvent = debounce(() => {
    const shouldListenForNotifications = false;

    if (shouldListenForNotifications) {
      this.getNotifications('unread', true);
    }
  }, FCM_NOTIFICATIONS_DEBOUNCE_DELAY);

  getNotificationData = async () => {
    await this.getNotifications('unread', true);

    if (this.notifications) {
      return this.mapNotifications(this.notifications.unread);
    }
  };

  private mapNotifications = (
    notifications: AlertsUnion[],
  ): ITVNotification[] =>
    notifications.map<ITVNotification>(item => ({
      id: item.id,
      time: item.createdDate,
      title: item.title,
      text: item.desc,
    })).sort(
      (a, b) => a.time - b.time,
    );

  getNotifications = async (status: AlertStatus, isUpdate = false) => {
    // @ts-ignore needs cuz of changed response type
    const response: NotificationInboxResponse = await Fetch.request(
      'NOTIFICATION',
      '/v1/inbox',
      'GET_LATEST_INBOX',
      {
        query: {
          status,
          records: 40,
        },
      },
    );

    if (response.success) {
      this.setNotifications(status, response.data.notifications);

      if (isUpdate && broker.instance) {
        broker.instance.updateNotifications(
          this.mapNotifications(this.notifications.unread),
        );
      }
    }
  };

  sendTechIssueNotification = (type: 'BOTH' | 'LIVE' | 'MARKET') => {
    this.pushAlertByType('notice', 'WS_CONNECTION', {
      type: 'notice',
      title: LocaleStore.translate(TECH_ISSUE_TITLE[type]),
      description: LocaleStore.translate('TECH_ISSUES_DESCRIPTION'),
      action: {
        type: 'button',
        actionCallback: () => window.location.reload(),
        btnText: LocaleStore.translate('RELOAD_APP'),
      },
      icon: ErrorCircleIcon,
      iconProps: {
        color: 'data.yellow',
        size: 'small',
      },
    });
  };
}

export default new NotificationsService();
